import { render } from "./RegistrationProfessionDetail.vue?vue&type=template&id=7e463d4c&scoped=true&ts=true"
import script from "./RegistrationProfessionDetail.vue?vue&type=script&lang=ts"
export * from "./RegistrationProfessionDetail.vue?vue&type=script&lang=ts"

import "./RegistrationProfessionDetail.vue?vue&type=style&index=0&id=7e463d4c&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e463d4c"]])

export default __exports__